import { render, staticRenderFns } from "./popupAmulets.vue?vue&type=template&id=305d092c&scoped=true&"
import script from "./popupAmulets.vue?vue&type=script&lang=js&"
export * from "./popupAmulets.vue?vue&type=script&lang=js&"
import style0 from "./popupAmulets.vue?vue&type=style&index=0&id=305d092c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "305d092c",
  null
  
)

export default component.exports